module.exports = __webpack_public_path__ + "img/img-intro-app-2-tw.43dd1d5f.svg";